// =============================================================================
// Mega Menu Hover Handler
// Copied from WordPress theme app.js
// =============================================================================

function initMegaMenu() {
  var offcanvasElementList = [].slice.call(document.querySelectorAll('.tif-mega-menu')),
      navItemList = [].slice.call(document.querySelectorAll('.tif-navigation a[aria-controls]')),
      navigationEl = document.querySelector('.tif-navigation'),
      eventToggle = navigationEl ? navigationEl.getAttribute('data-toggle-event') : null,
      hoverSubmenu = false,
      hoverNavItem = null,
      timeoutHandler = null,
      timer = 0;

  if (offcanvasElementList.length) {
    var offcanvasList = offcanvasElementList.map(function (offcanvasEl) {
      return new window.bootstrap.Offcanvas(offcanvasEl)
    });

    offcanvasList.forEach(el => {

      // Toggle navigation active state
      el._element.addEventListener('show.bs.offcanvas', function() {
        document.querySelector('.tif-navigation a[aria-controls="'+ el._element.id +'"]').setAttribute('aria-expanded', 'true');
      });

      el._element.addEventListener('hidden.bs.offcanvas', function() {
        document.querySelector('.tif-navigation a[aria-controls="'+ el._element.id +'"]').setAttribute('aria-expanded', 'false');
      });

      // Hover events for mega menu
      if (eventToggle) {
        el._element.addEventListener('mouseenter', function() {
          el.show();
          hoverSubmenu = true;
        });

        el._element.addEventListener('mouseleave', function() {
          setTimeout(function() {
            if (!hoverNavItem) {
              el.hide();
              hoverSubmenu = false;
            }
          }, timer);
        });
      }
    });

    // Hover events for navigation
    if (eventToggle) {
      if (navItemList.length) {
        navItemList.forEach(el => {
          let target = el.getAttribute('data-bs-target'),
              targetElement = document.querySelector(target),
              offcanvas = window.bootstrap.Offcanvas.getInstance(targetElement);

          el.addEventListener('mouseenter', function() {
            hoverNavItem = el;
            hoverSubmenu = false;

            window.clearTimeout(timeoutHandler);

            offcanvasList.forEach(_el => {
              if (_el._element.id != el.getAttribute('aria-controls')) {
                _el.hide();
              }
            });

            setTimeout(function() {
              offcanvas.show();
            }, timer);
          });

          el.addEventListener('mouseleave', function() {
            hoverNavItem = null;

            timeoutHandler = setTimeout(function() {
              if (!hoverSubmenu) {
                offcanvas.hide();
              }
            }, timer);
          });

        });
      }
    }

    function mega_menu_resize() {
      var window_width = window.innerWidth,
          threshold = 992;

      if (window_width < threshold) {
        offcanvasList.forEach(el => {
          if (el._isShown) {
            el.hide();
          }
        });
      }
    }

    mega_menu_resize();
    window.addEventListener('resize', mega_menu_resize);
  }
}

// Don't auto-execute - will be called manually from app.js after Bootstrap is ready
export default initMegaMenu;
